import { ChamberMember, CodebookModel } from 'app/shared/model/shared.model';
import { LegalEntityModel } from 'app/shared/oib/oib.model';
import { AddressModel, initialAddress } from 'app/shared/address-input/model/address.model';

export interface ProjectDocumentsModel {
  idProjectDocument?: number;
  projectType: CodebookModel[];
  projectMark: string;
  additionalDescription: string;
  projectCreatedDate: Date;
  projectMap: CodebookModel[];
  authorizedDesigner: ChamberMember;
  designerOffice: DesignerOffice;
  authorizationNumberExists: boolean;
  v2card: boolean;
  designerFirstName: string;
  designerLastName: string;
  designerTitle: string;
  email?: string;
  telephoneNumber?: string;
}

export interface DesignerOffice {
  subjectType: CodebookModel[];
  legalEntity: LegalEntityModel;
  address: AddressModel;
  oibFetched: boolean;
}

export interface ProjectDocumentView {
  idProjectDocument: number;
  projectType: string;
  additionalDescription: string;
  authorizedDesigner: string;
  designerOfficeAddress: string;
  projectMap: string;
  projectMark: string;
  projectCreatedDate: Date;
  hasAttachments: boolean;
  canEdit: boolean;
  canDelete: boolean;
  ordering: number;
}

export interface ProjectDocumentAttachmentView {
  idProjectDocumentAttachment: number;
  name: string;
  createdDate: Date;
  lastValidSignature: string;
  lastSignerInstitution: string;
  status: boolean;
  canDelete: boolean;
}

export const initialProjectDocument = {
  projectType: [],
  projectMark: '',
  additionalDescription: '',
  projectCreatedDate: '',
  projectMap: [],
  authorizedDesigner: {
    authorizationNumber: [],
    oib: '',
  },
  designerOffice: {
    oibFetched: true,
    subjectType: [],
    legalEntity: {
      mb: '',
      oib: '',
      companyName: '',
      address: null,
    },
    address: initialAddress,
  },
  authorizationNumberExists: true,
  v2card: false,
  designerFirstName: '',
  designerLastName: '',
  designerTitle: '',
  email: '',
  telephoneNumber: '+385',
};
